/**
   * @name FleetService
   * @author Surjeet Bhadauriya <surjeet.bhadauriya@techifysolutions.com>
   * @description All APIs for fleet registration
   * @version 0.0.1
   */
import { request } from './Request';
import { routes } from '../constants/constant.route';

const {
  GET_FLEET_DATA,
  GET_VEHICALE_TYPE,
  GET_VEHICALE_MAKE,
  POST_FLEET_DATA,
  DELETE_FLEET,
  UPDATE_FLEET,
  GET_BUSINESS_RELATED_DETAILS,
  UPDATE_BAADSHAH_PROFILE_CATEGORY
} = routes.FLEET_REGISTRATION;

const API_URL = process.env.REACT_APP_API_URL;

export default class FleetService {

  /**
    * @name getVehicleType
    * @description Redirect to profile page
    * @param {}
    */
  static cancel() {
    // cancel action here
  }

  /**
 * @name getFleetData
 * @description Get Fleet Data
 * @param {}
 * @method GET
 * @returns promise
 */
  static getFleetData(id = null) {
    if (id) {
      return request('GET', `${API_URL}${routes.NEW_FLEET.GET_FLEET_DATA}?id=${id}`, null, null, null);
    } else {
      return request('GET', `${API_URL}${GET_FLEET_DATA}`, null, null, null);
    }
  }

  static getFleetDataProfile(id = null) {
    let qp = '';
    if (id) {
      qp = `?uuid=${id}`;
    }
    return request('GET', `${API_URL}${GET_FLEET_DATA}${qp}`, null, null, null);
  }

  static getBusinessRelatedDetails(id = null) {
    if (id) {
      return request('GET', `${API_URL}${routes.NEW_FLEET.GET_BUSINESS_RELATED_DETAIL}?id=${id}`, null, null, null);
    }
    else {
      return request('GET', `${API_URL}${GET_BUSINESS_RELATED_DETAILS}`, null, null, null);
    }
  }

  static getBusinessRelatedDetailsProfile(id = null) {
    let qp = '';
    if (id) {
      qp = `?id=${id}`;
    }
    return request('GET', `${API_URL}${GET_BUSINESS_RELATED_DETAILS}${qp}`, null, null, null);
  }

  /**
   * @name getVehicleType
   * @description Get Vehicle Type : Bus, Truck
   * @param {}
   * @method GET
   * @returns promise
   */
  static getVehicleType() {
    return request('GET', `${API_URL}${GET_VEHICALE_TYPE}`, null, null, null);
  }

  /**
   * @name getVehicalMake
   * @description Get Vehicle Brand : Mahindra, Tata
   * @param {params: Object}
   * @method GET
   * @returns promise
   */
  static getVehicalMake(params) {
    return request('GET', `${API_URL}${GET_VEHICALE_MAKE}`, params, null, null);
  }

  /**
   * @name postFleetRegistration
   * @description Saves the data of fleet registration
   * @param {data: Object}
   * @method POST
   * @returns promise
   */
  static postFleetRegistration(data) {
    if (data.temp_id) {
      return request('POST', `${API_URL}${routes.NEW_FLEET.POST_FLEET_DATA}`, null, data, null);
    } else {
      return request('POST', `${API_URL}${POST_FLEET_DATA}`, null, data, null);
    }
  }

  static postFleetRegistrationProfile(data) {
    let qp = '';
    if (data.fleet_id) {
      qp = `?id=${data.fleet_id}`;
    }
    return request('POST', `${API_URL}${POST_FLEET_DATA}${qp}`, null, data, null);
  }

  /**
 * @name deleteFleet
 * @description deleteFleet
 * @param {data: string}
 * @method POST
 * @returns promise
 */
  static deleteFleet(q, temp_id = null) {
    if (temp_id) {
      return request('DELETE', `${API_URL}${routes.NEW_FLEET.GET_FLEET_DATA}?temp_id=${temp_id}&&fleet_id=${q.fleetId}&count=${q.totalTyre}`, null, null, null);
    } else {
      return request('DELETE', `${API_URL}${DELETE_FLEET}?fleet_id=${q.fleetId}&count=${q.totalTyre}`, null, null, null);
    }
  }

  /**
* @name updateFleet
* @description updateFleet
* @param {data: Object}
* @method POST
* @returns promise
*/
  static updateFleet(data) {
    if (data.temp_id) {
      return request('PUT', `${API_URL}${routes.NEW_FLEET.GET_FLEET_DATA}`, null, data, null);
    } else {
      return request('PUT', `${API_URL}${UPDATE_FLEET}`, null, data, null);
    }
  }

  static updateFleetProfile(data) {
    let qp = '';
    if (data.fleet_id) {
      qp = `?id=${data.fleet_id}`;
    }
    return request('PUT', `${API_URL}${UPDATE_FLEET}${qp}`, null, data, null);
  }

  static updateBusinessRelatedDetails(data) {
    if (data.temp_id) {
      return request('PUT', `${API_URL}${routes.NEW_FLEET.UPDATE_BUSINESS_RELATED_DETAIL}`, null, data, null);
    } else {
      return request('PUT', `${API_URL}${routes.FLEET_REGISTRATION.UPDATE_BUSINESS_RELATED_DETAIL}`, null, data, null);
    }
  }

  static updateBusinessRelatedDetailsProfile(data) {
    let qp = '';
    if (data.f_id) {
      qp = `?id=${data.f_id}`;
    }
    return request('PUT', `${API_URL}${routes.FLEET_REGISTRATION.UPDATE_BUSINESS_RELATED_DETAIL}${qp}`, null, data, null);
  }

  static getBrand(reqData) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_BRAND}`, reqData, null, null);
  }

  static getBrandPattern(reqData) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_BRAND_PATTERN}`, reqData, null, null);
  }


  /**
   * @name checkUserAgent
   * @description detect browser or mobile
   * @param {}
   * @returns Boolean
   */
  static checkUserAgent() {
    const ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      return true;
    } if (/Chrome/i.test(ua)) {
      return false;
    }
    return false;

  }

  static updateBaadshsaCategory() {
    return request('POST', `${API_URL}${UPDATE_BAADSHAH_PROFILE_CATEGORY}`, null, null, null);
  }


  static getFleetDetailCard() {
    return request('GET', `${API_URL}${routes.FLEET_DETAIL.FLEET_DETAILS_CARD}`, null, null, null);
  }
  static getFleetDetailData(reqData) {
    return request('GET', `${API_URL}${routes.FLEET_DETAIL.GET_FLEET_DETAIL}`, reqData, null, null);
  }
  static downloadfleetreport(reqdata) {
    return request(
      "GET",
      `${API_URL}${routes.DASHBOARD.DOWNLOAD_FLEET_REPORT_SIDENAV}`,
      reqdata,
      null,
      null
    );
  }
  static buildRegistrationObject(state) {
    let obj = {};
    if (state) {
      const { customerDetails, vehicleDetails, productDetails } = state;

      obj = {
        first_name: customerDetails.firstname.value,
        last_name: customerDetails.lastname.value,
        email_id: customerDetails.email.value,
        country_code: '+91',
        phone_number: customerDetails.phoneNumber.value,
        state_id: vehicleDetails.state.value.state_id,
        city_id: vehicleDetails.city.value.city_id,
        vehicle_type_id: vehicleDetails.vehicleTypeId.value.vehicle_type_id,
        vehicle_type_brand_id: vehicleDetails.vehicleTypeBrandId.value.brand_id,
        vehicle_type_brand_model_id: vehicleDetails.vehicleTypeBrandModelId.value.model_id,
        vehicle_type_brand_model_variation_id: vehicleDetails.vehicleTypeBrandModelVariationId.value.variation_id,
        registration_number: vehicleDetails.registrationNumber.value,
        registration_year: vehicleDetails.registrationYear.value,
        vehical_meter_reading: vehicleDetails.verhicleMeterReading.value,
        vehical_avg_monthly_running: vehicleDetails.vehicleAvgMonthlyRunning.value,
        tyre_qty: productDetails.tyreQuantity.value,
        tyre_description: [],
        sku_id_1: '',
        sku_id_spare: '',
        sku_id_back: '',
        is_edit: false
      };

      if (vehicleDetails.vehicleTypeId && vehicleDetails.vehicleTypeId.value && (vehicleDetails.vehicleTypeId.value.name).toLowerCase() === 'car') {
        obj.sku_id_1 = productDetails.skuId1.value;

        if (productDetails.frontTyre1 && productDetails.frontTyre1.value) {
          obj.tyre_description.push(productDetails.frontLeftStencilNumber.value);
        }

        if (productDetails.frontTyre2 && productDetails.frontTyre2.value) {
          obj.tyre_description.push(productDetails.frontRightStencilNumber.value);
        }

        if (productDetails.backTyre1 && productDetails.backTyre1.value) {
          obj.tyre_description.push(productDetails.rearLeftStencilNumber.value);
        }

        if (productDetails.backTyre2 && productDetails.backTyre2.value) {
          obj.tyre_description.push(productDetails.rearRightStencilNumber.value);
        }

        if (productDetails.squareTyre && productDetails.squareTyre.value) {
          obj.tyre_description.push(productDetails.spareStencilNumberCar.value);
        }
      } else {
        if (productDetails.frontTyre1 && productDetails.frontTyre1.value) {
          obj.sku_id_1 = productDetails.skuId1.value;
          obj.tyre_description.push(productDetails.frontStencilNumber.value);
        }

        if (productDetails.frontTyre2 && productDetails.frontTyre2.value) {
          obj.sku_id_back = productDetails.skuIdBack.value;
          obj.tyre_description.push(productDetails.rearStencilNumber.value);
        }

        if (productDetails.squareTyre && productDetails.squareTyre.value) {
          obj.tyre_description.push(productDetails.spareStencilNumberBike.value);
          obj.sku_id_spare = productDetails.skuIdSpare.value;
        }

      }
    }
    return obj;
  }

}